import styled from 'particles/themes/styled'
import { theme } from 'theme'

export const TextProgressContainer = styled.div`
    width: fit-content;
    display: flex;
    flex-direction: row;
`

export const DeadlineHeaderContainer = styled.div`
    min-width: fit-content;
    width: 100%;
    box-sizing: border-box;
    background-color: ${theme.newColors.neutral50};
    @media screen and (max-width: 768px) {
        width: calc(100% - 50px);
        min-width: auto;
    }
    .container {
        width: 100%;
        display: flex;
        justify-content: space-between;
        gap: 16px;
        box-sizing: border-box;
        padding: 12px;
        flex-direction: row;
        border-radius: 4px;
        @media screen and (max-width: 768px) {
            flex-direction: column;
        }
    }
    .slot {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
        white-space: nowrap;
    }
    .progress-timeline-container {
        display: flex;
        gap: ${({ theme }) => theme.spacing[300]};
        justify-content: space-between;
        @media screen and (max-width: 375px) {
            flex-wrap: wrap;
            display: block;
        }
    }
    .timeline-container {
        display: flex;
        gap: ${({ theme }) => theme.spacing[200]};
        align-items: center;
        .divider {
            width: 1px;
            background: ${({ theme }) => theme.colors.divider.primary};
        }
        @media screen and (max-width: 375px) {
            position: relative;
            margin-top: ${({ theme }) => theme.spacing[300]};
        }
        @media screen and (max-width: 320px) {
            flex-wrap: wrap;
        }
    }
    .reminder-container {
        width: 600px;
        margin-left: auto;
        @media screen and (max-width: 768px) {
            text-align: right;
            width: 100%;
        }
        @media screen and (max-width: 375px) {
            text-align: left;
            width: 100%;
        }
        .warning {
            margin-left: auto;
            @media screen and (max-width: 375px) {
                margin-left: 0;
            }
        }
    }
    .extend-deadline-button {
        position: relative;
        @media screen and (max-width: 375px) {
            margin-left: auto;
        }
    }
`
